<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_settings'] == 1">
      <div class="col-12">
        <div class="card shadow-lg">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-prn size="sm" variant="primary"
                ><i class="mdi mdi-plus"></i> New Subscription</b-button
              >
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select
                      class="form-select form-select-sm mx-1"
                      v-model="perPage"
                      size="sm"
                      :options="Options"
                    ></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
                <template #table-busy
                  ><div class="text-center text-primary my-2">
                    <b-spinner
                      class="align-middle"
                      type="grow"
                      small
                    ></b-spinner>
                    <strong>No Data Found</strong>
                  </div></template
                >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(telephone)="data">
                  {{ data.item.telephone }} <br /><span style="color: green;">{{
                    data.item.refernce
                  }}</span>
                </template>
                <template #cell(updated_at)="data">
                  {{
                    new Date(data.item.updated_at).toLocaleDateString(
                      "en-US",
                      options,
                    )
                  }}
                </template>
                <template #cell(addedby)="data">
                  {{ data.item.addedby }}
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="List"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Redesigned Modal with Payment Page Fields -->
      <b-modal
        id="new-prn"
        centered
        title="New Subscription"
        title-class="font-18"
        hide-footer
        size="lg"
      >
        <form @submit.prevent="pay">
          <!-- Service Type Selection -->
          <div class="form-group mb-3">
            <label class="font-weight-bold mb-2">Service Type</label>
            <div class="d-flex gap-2">
              <b-button
                v-for="s in services"
                :key="s"
                :variant="service === s ? 'primary' : 'outline-secondary'"
                class="flex-grow-1"
                @click="
                  service = s;
                  FindProduct();
                "
              >
                <i
                  :class="
                    s === 'Software Subscription'
                      ? 'mdi mdi-laptop'
                      : 'mdi mdi-message-text-outline'
                  "
                  class="me-2"
                ></i>
                {{ s }}
              </b-button>
            </div>
          </div>

          <!-- Package Selection -->
          <div class="form-group mb-3">
            <label class="font-weight-bold mb-2">Package</label>
            <v-select
              :options="products"
              @input="FindPrice"
              placeholder="Select a Package"
              v-model="product"
            ></v-select>
          </div>

          <!-- Months Duration (Only for Software Subscription) -->
          <div
            class="form-group mb-3"
            v-if="service === 'Software Subscription'"
          >
            <label class="font-weight-bold mb-2">Duration (Months)</label>
            <div class="d-flex align-items-center">
              <b-input-group style="max-width: 200px;">
                <b-input-group-prepend>
                  <b-button
                    variant="outline-secondary"
                    @click="decrementMonths"
                    :disabled="monthsToPay <= 1"
                  >
                    <i class="mdi mdi-minus"></i>
                  </b-button>
                </b-input-group-prepend>
                <b-form-input
                  v-model.number="monthsToPay"
                  @change="CalculateAmount"
                  type="number"
                  min="1"
                  class="text-center"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    variant="outline-secondary"
                    @click="incrementMonths"
                  >
                    <i class="mdi mdi-plus"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
              <span class="ms-3 text-muted" v-if="baseAmount > 0">
                UGX {{ formatAmount(baseAmount) }} / month
              </span>
            </div>
          </div>

          <!-- Amount Display -->
          <div class="form-group mb-3" v-if="calculatedAmount > 0">
            <label class="font-weight-bold mb-2">Total Amount</label>
            <div class="alert alert-success bg-light-success border-0">
              <h4 class="mb-0 text-success">
                UGX {{ formatAmount(calculatedAmount) }}
                <small
                  v-if="service === 'Software Subscription' && monthsToPay > 1"
                  class="text-muted"
                >
                  ({{ monthsToPay }} month{{ monthsToPay > 1 ? "s" : "" }})
                </small>
              </h4>
            </div>
          </div>

          <!-- Mobile Money Number -->
          <div class="form-group mb-3">
            <label class="font-weight-bold mb-2">Mobile Money Number</label>
            <b-input-group prepend="+256">
              <b-form-input
                v-model="telephone"
                placeholder="Enter Telephone Number"
                v-mask="'#########'"
                type="text"
              ></b-form-input>
            </b-input-group>
            <small class="form-text text-muted">
              <i class="mdi mdi-information-outline me-1"></i>
              A payment prompt will be sent to this number
            </small>
          </div>

          <!-- Form Actions -->
          <div class="form-group d-flex justify-content-end mt-4">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="resetAndClose"
            >
              Close
            </b-button>
            <b-button type="submit" class="btn ms-1 w-30" variant="primary">
              <i class="fas fa-check-circle"></i> Submit Payment
            </b-button>
          </div>
        </form>
      </b-modal>

      <b-modal id="waiting-confirm" centered title-class="font-18" hide-footer>
        <div class="text-center">
          <b>{{ responseMessage }}</b
          ><br /><br />
          <b-spinner
            class="align-middle"
            type="grow"
            style="width: 5rem; height: 5rem;"
          ></b-spinner>
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button
            type="button"
            class="btn w-30"
            variant="secondary"
            @click="$bvModal.hide('waiting-confirm')"
            >Close</b-button
          >
        </div>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
            <center>
              <span class="text-primary h6"
                >You have no permission to view this Page.</span
              >
            </center>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { subscriptionMethods, subscriptionComputed } from "@/state/helpers";

export default {
  page: {
    title: "Subscriptions",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Subscriptions",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Subscriptions", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "service", label: "Service", visible: true },
        { key: "telephone", label: "Telephone", visible: true },
        { key: "amount", label: "Amount", visible: true },
        { key: "months_paid", label: "Duration(months)", visible: true },
        { key: "updated_at", label: "Paid On", visible: true },
        { key: "addedby", label: "Added By", visible: true },
      ],
      id: "",
      name: "",
      services: ["Software Subscription", "SMS Purchase"],
      service: "",
      products: [],
      product: "",
      amount: "",
      telephone: "",
      responseMessage: "",
      options: {
        weekday: "short",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
      },
      addedby: "",
      // New properties for enhanced modal
      monthsToPay: 1,
      baseAmount: 0,
      interval: null,
    };
  },
  computed: {
    ...subscriptionComputed,
    List() {
      return this.subscriptions.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.subscriptions.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.subscriptions.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    calculatedAmount() {
      return this.baseAmount * this.monthsToPay;
    },
  },

  mounted() {
    this.fetchSubscriptions();
    this.TotalRows = this.subscriptions.length;
    this.isBusy = false;
  },
  methods: {
    ...subscriptionMethods,
    formatAmount(amount) {
      return Number(amount)
        .toFixed(0)
        .replace(/\d(?=(\d{3})+$)/g, "$&,");
    },
    decrementMonths() {
      if (this.monthsToPay > 1) {
        this.monthsToPay--;
        this.CalculateAmount();
      }
    },
    incrementMonths() {
      this.monthsToPay++;
      this.CalculateAmount();
    },
    resetAndClose() {
      this.resetForm();
      this.$bvModal.hide("new-prn");
    },
    resetForm() {
      this.service = "";
      this.product = "";
      this.telephone = "";
      this.monthsToPay = 1;
      this.baseAmount = 0;
      this.amount = 0;
    },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    FindProduct() {
      if (this.service == "Software Subscription") {
        this.products = ["Termly Subscription"];
      } else {
        this.products = [
          "Starter Pack - 2500 sms",
          "Premium Pack - 5000 sms",
          "Enterprise Pack - 10000 sms",
        ];
      }
      this.product = "";
      this.baseAmount = 0;
      this.amount = 0;
      this.monthsToPay = 1;
    },
    FindPrice() {
      if (this.product == "Termly Subscription") {
        // Fetch base amount from user data (from backend)
        this.baseAmount = this.userData.monthly_charge || 50000;
      } else if (this.product == "Starter Pack - 2500 sms") {
        this.baseAmount = 1000;
      } else if (this.product == "Premium Pack - 5000 sms") {
        this.baseAmount = 30000;
      } else if (this.product == "Enterprise Pack - 10000 sms") {
        this.baseAmount = 50000;
      } else {
        this.baseAmount = 0;
      }
      this.CalculateAmount();
    },
    CalculateAmount() {
      if (!this.monthsToPay || this.monthsToPay < 1) this.monthsToPay = 1;
      this.amount = this.baseAmount * this.monthsToPay;
    },
    async pay() {
      let formData = new FormData();
      formData.append("telephone", this.telephone);
      formData.append("amount", this.amount);
      formData.append("service", this.product);
      formData.append("months_paid", this.monthsToPay);

      // Updated route to renewsubscription
      let url = "/renewsubscription";

      await axios
        .post(url, formData)
        .then((response) => {
          if (response.data.code == 200) {
            this.responseMessage = response.data.message;
            this.$bvModal.hide("new-prn");
            this.$bvModal.show("waiting-confirm");

            // Open payment link if provided
            if (response.data.payment_link) {
              window.open(response.data.payment_link, "_blank");
            }

            // Updated interval time to 25 seconds (from payment page)
            this.interval = setInterval(async () => {
              await this.ConfirmPayment(response.data.reference);
            }, 25000);
          } else {
            this.$swal({
              title: "Error",
              text: response.data.message || "Payment initiation failed",
              icon: "error",
            });
          }
        })
        .catch
        //(error) => {
        //   this.$swal({
        //     title: "Error",
        //     text: "Network error. Please try again.",
        //     icon: "error",
        //   });
        // }
        ();
    },

    async ConfirmPayment(reference) {
      let formData = new FormData();
      formData.append("reference", reference);

      // Updated route to confirmsubscription
      let url = "/confirmsubscription";

      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          if (response.data.code == "200") {
            this.$bvModal.hide("waiting-confirm");
            clearInterval(this.interval);
            this.fetchSubscriptions(); // This returns the updated subscriptions
            this.$swal({
              title: "Success",
              text: response.data.message + " License has been renewed.",
              icon: "success",
              timer: 3000,
              showConfirmButton: false,
            });
            this.resetForm();
            // Redirect to login after successful payment (from payment page)
            this.$router.push("/login");
          } else if (response.data.message == "failed") {
            this.$bvModal.hide("waiting-confirm");
            clearInterval(this.interval);
            this.resetForm();
            this.$swal({
              title: "Payment Failed",
              text:
                response.data.message + " Please try again or contact support.",
              icon: "error",
              timer: 4000,
              showConfirmButton: false,
            });
          }
        }
      });
    },
  },
  destroyed() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
};
</script>

<style scoped>
.gap-2 {
  gap: 0.5rem;
}
.w-30 {
  width: 30%;
}
.bg-light-success {
  background-color: #e8f5e9;
}
</style>
